<template>
  <EdroneModal :open="open" :width="500" @close="handleClose">
    <EdroneHeader :title="trans._segmentation.engagementTab.addClient.header" class="tw:mb-2" type="h2" />
    <div class="tw:grid tw:grid-cols-2 tw:gap-4 tw:mb-2">
      <EdroneInput
        v-model.trim="form.firstName"
        :label="trans._segmentation.engagementTab.addClient.firstName"
        :placeholder="trans._segmentation.engagementTab.addClient.firstNamePlaceholder"
        class="tw:w-full"
        required
      />

      <EdroneInput
        v-model.trim="form.lastName"
        :label="trans._segmentation.engagementTab.addClient.lastName"
        :placeholder="trans._segmentation.engagementTab.addClient.lastNamePlaceholder"
        class="tw:w-full"
        required
      />
    </div>

    <EdroneInput
      v-model.trim="form.email"
      :label="trans._segmentation.engagementTab.addClient.email"
      :placeholder="trans._segmentation.engagementTab.addClient.emailPlaceholder"
      class="tw:w-full tw:mb-2"
      required
      type="email"
    />

    <div class="tw:flex tw:justify-end tw:gap-3">
      <EdroneButton class="tw:flex-1" type="outline" @click="handleClose">
        {{ trans._segmentation.engagementTab.addClient.cancel }}
      </EdroneButton>
      <EdroneButton :loading="isSubmitting" class="tw:flex-1" type="solid" @click="handleSubmit">
        {{ trans._segmentation.engagementTab.addClient.add }}
      </EdroneButton>
    </div>
  </EdroneModal>
</template>

<script lang="ts" setup>
import { ref, reactive, watch } from "vue";
import EdroneModal from "edrone-components/EdroneModal.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import EdroneInput from "edrone-components/EdroneInput.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";
import axios from "axios";

interface Props {
  open: boolean;
}

interface Emits {
  (event: "close"): void;
  (event: "success", clientId: number): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const isSubmitting = ref(false);
const form = reactive({
  firstName: "",
  lastName: "",
  email: "",
});

const resetForm = () => {
  form.firstName = "";
  form.lastName = "";
  form.email = "";
};

const trans = window._trans;

const handleSubmit = async () => {
  isSubmitting.value = true;
  try {
    const formData = new FormData();
    formData.append("first_name", form.firstName.trim());
    formData.append("last_name", form.lastName.trim());
    formData.append("email", form.email.trim());
    const response = await axios.post("/json/customer/create", formData);
    emit("success", response.data.customerId);
    resetForm();
  } catch (error) {
    console.error("Error creating customer:", error);
    window.showToast(trans._segmentation.engagementTab.addClient.error, "error");
  } finally {
    isSubmitting.value = false;
  }
};

const handleClose = () => {
  resetForm();
  emit("close");
};

watch(
  () => props.open,
  () => {
    // No need to reset the form here; it is already reset on close.
  }
);
</script>
